define('drops/grid/gridPager',[
    'jquery'
], function($) {

    var GridPager = function (grid, $parent) {
        this.$element = $('<div class="pagerTable" />')
            .appendTo($parent);

        this.$firstDiv = $('<div  class="pagerCell"/>')
            .append($('<span class="pointer"/>')
                .on('click', function () {
                    grid.first();
                })
                .append($('<div class="pagerFirst" />')))
            .appendTo(this.$element);

        this.$previousDiv = $('<div class="pagerCell" />')
            .append($('<span class="pointer"/>')
                .on('click', function () {
                    grid.previous();
                })
                .append($('<div class="pagerPrevious" />')))
            .appendTo(this.$element);

        this.$pagerText = $('<div class="pagerText pagerCell" />')
                .appendTo(this.$element);

        this.$nextDiv = $('<div class="pagerCell"/>')
            .append($('<span class="pointer"/>')
                .on('click', function () {
                    grid.next();
                })
                .append($('<div class="pagerNext" />')))
            .appendTo(this.$element);

        this.$lastDiv = $('<div class="pagerCell" />')
            .append($('<span class="pointer"/>')
                .on('click', function () {
                    grid.last();
                })
                .append($('<div class="pagerLast" />')))
            .appendTo(this.$element);
    };

    GridPager.prototype.update = function (page, pageSize, totalResults) {
        var from = page * pageSize + 1;
        var to = totalResults < ((page + 1) * pageSize) ? totalResults : ((page + 1) * pageSize);

        if (from === 1) {
            this.$firstDiv.hide();
            this.$previousDiv.hide();
        }

        if (to === totalResults) {
            this.$nextDiv.hide();
            this.$lastDiv.hide();
        }
        
        if (totalResults === 0)
            this.setPagerText(' 0 .. 0 (0) ');
        else
            this.setPagerText(' ' + from + ' .. ' + to + ' (' + totalResults + ') ');
    };

    GridPager.prototype.setPagerText = function(text) {
        this.$pagerText.text(text);
    };

    return GridPager;
});
